import _ from './lib/underscore_extend';
import $ from 'jquery';
import Backbone from 'backbone';

import Application from './lib/application';

window.jQuery = $;
window.$ = $;
window._ = _;

export default Application;
export {
    $,
    _,
    Backbone
}



// WEBPACK FOOTER //
// ./~/wgnet-awesomejs/index.js